import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';
import GalleryGridFront from './layout/portfolio/GalleryGridFront';
import BriefIcon from './layout/hero/BriefIcon';
import WarpLarge from './layout/warp/WarpLarge';
import NextUp from './layout/warp/NextUp';

import Paragraph from './layout/Paragraph';
import ProcessThreeSteps from './layout/Process';

import ImageGridx1 from './layout/portfolio/ImageGridx1';
import ImageGridx2 from './layout/portfolio/ImageGridx2';
import ImageGridx3 from './layout/portfolio/ImageGridx3';

import GalleryGridx1 from './layout/portfolio/GalleryGridx1';
import GalleryGridx2 from './layout/portfolio/GalleryGridx2';
import VideoMockup from './layout/portfolio/VideoMockup';
import PenIcon from './asset/PenIcon';

import Front from './img/SEEK/SK_Cover@2x.jpg';
import FrontCompany from './img/SEEK/SK_Main@2x.png';

import SKSynthesise from './img/SEEK/SK_Synthesized@2x.png'
import SKInterview from './img/SEEK/SK_Interview@2x.png'
import SK_flowLicence from './img/SEEK/SK_Structureddataflow@2x.png'
import SKTest_result from './img/SEEK/SK_ClickTest_analyst@2x.png'
import SKTest from './img/SEEK/SK_ClickTest@2x.png'
import SKTreeTest from './img/SEEK/SK_TreeTest_analyst@2x.png'
import SKIdeation from './img/SEEK/SK_ideation@2x.jpg'
import SKMentalModel from './img/SEEK/SK_MentalModel@2x.jpg'



// Summary
const companyInfo = {
  title: "Helping job seekers to stand out",
  name: "SEEK",
  themeColor: "#3158A1",
  themeTextColor: "white",
  frontImage: Front,
  role: "UX designer",
  fields: "Research, UX design",
  time: "JUN 2019 – Present",
  paragraph:"During the time I've worked as a product designer, I always aspired to spend more time on research. I joined SEEK back in mid-2019, and started to build up a career as a liaison between the business direction and the user needs. I've been responsible for conducting user research, creating surveys, and analysing usage patterns to achieve strategic goals with people in mind."
}

const list = ["Capable of using the right UX research framework at each stage of the project.", "Evaluate and filter early ideas and opinions by conducting user interviews.", "Utilise SEEK’s branding and visual language, with a twist of new ideas.", "Streamline design process under agile development."]

const metatag = {
  title: "Portfolio ✴︎ " + companyInfo.name,
  author: "Jinju Jang",
  url: "http://jinju.io/seek",
  description: companyInfo.paragraph,
  image: "http://jinju.io" + companyInfo.frontImage,
}

// About sportsmate
const aboutSEEK = {
  summary: "About the company",
  titleIcon: PenIcon,
  title: "Who are SEEK?",
  paragraph: "SEEK is the leading employment marketplace in Australia. Founded in 1997, SEEK has been used by millions of job seekers over 20 years to find their next career. The company also operates many subsidiary businesses across APAC and America.",
  themeColor: '#951951',
  textColor: '#ffffff',
  image: FrontCompany,
}

const SKProfile = {
  summary:"The opportunity",
  heading:"The profile is the new resume. SEEK launched SEEK Profile to progress on to the new paradigm.",
  paragraph:"People used to flick through newspapers to find out jobs in their local areas. Back in early 2000s, SEEK was launched and changed the way Australian people finding jobs from newspapers to a website. This was a huge innovation at that time.",
  paragraph_2: "However, now SEEK's early innovation is challenged with another innovation. Ever since social media started influencing the way we think, it's naturally become a type of job marketplace. More people started to realise that sharing updates in their professional network can be more effective than applying for a job with a resume.",
  paragraph_3: "SEEK also read the change in trend and started a strategy to enhance profile experience to be ready for the future. As a UX Designer, I've joined the team to research and improve the experience in order to help business success in the new paradigm."
}

const SKDiscvoer = {
  summary:"Humanise strategic plans",
  heading:"I conducted research to simulate and find out what would happen if we execute the strategy.",
  paragraph: "As the business sees the value from SEEK profile, there were many plans created by stakeholders to achieve success with structured data. The strategic plans can be too business-driven hence the UX team wanted to find a balance.",
  paragraph_2: "My goal was to assist the strategic direction from the user's point of view. I conducted research to identify opportunities and risks coming from the new direction. I established a mock scenario the business wanted to pursue, to find out which parts are easy to adapt from our users, and which parts are feeling uncomfortable or risky for them.",
  paragraph_3:"The main area of my research was career data, especially in acquiring, controlling, and keeping it relevant. Across different user studies, I kept a consistent theme to find how SEEK can empower job-seekers to have a higher chance of being shortlisted.",
  paragraph_4:"From opt-in vs opt-out approaches with data acquisition, making it easy to understand the algorithm, and how fresh the career information should be... I researched various types of job seekers to find insights. Those findings have been helping the company to shape our product to be truly on the user's side.",
  caption: "At the beginning, I started with creating a user journey map to understand how the strategic plan will impact on the end-to-end user journey.",
  caption_2: "I interviewed real job seekers with a virtual scenario to identify potential risks to mitigate. Also, I analysed the dialogue with tagging and grouping."
}

const SKUsabilityTesting = {
  summary:"Using metrics for design decisions",
  heading:"Using early research helped the company to make informed decisions when it's less feasible to build A/B.",
  paragraph:"Not every design decision is easy to make. Stakeholders often suggest we should keep both options open and run an A/B testing to finalise. Unfortunately, we don't always have the time and budget to build two separate experiences. Oh no, what should we do?",
  paragraph_2: "As a UX designer, I found the solution to this problem from earlier design testing. If we can compare the A/B options upfront to get measurable data, it will help us not rush on building the easiest solution. With this hypothesis in mind,  I created the entire set of prototypes with low fidelity sketches. The childlike sketches intentionally separated the UI patterns and UI styles from our minds. AKA the “Make it work first” approach.",
  paragraph_3:"The research helped close design debates with measurable elements – time, success rate, directness. Since low-fidelity wireframes are easy to create, I stretched the goal and tested more patterns upfront. The findings were used to make informed decisions and helped other UXers conduct similar research.",
  caption:"The user testing gave us an idea of what would be the more optimal UI pattern, based on the combination of time (how fast), success rate (less error), and directness (how clear)",
  caption_2: "To figure out which section of the profile is hard to navigate through, I used tree-testing to measure how well participants can navigate to the menu based on the name."
}




class PortfolioSEEK extends Component {
  render() {
    return (
      <div>
        {/*Meta data*/}
        <Helmet>
          <meta charSet="utf-8"/>
          <title>{metatag.title}</title>
          <meta name="author" content={metatag.author}/>
          <meta name="description" content={metatag.description}/>

          {/*-- Google / Search Engine Tags --*/}
          <meta itemprop="name" content={metatag.title}/>
          <meta itemprop="description" content={metatag.description}/>
          <meta itemprop="image" content={metatag.image}/>

          {/*-- Open Graph / Facebook --*/}
          <meta property="og:url" content={metatag.url}/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={metatag.title} />
          <meta property="og:description" content={metatag.description}/>
          <meta property="og:image" content={metatag.image}/>

          {/*-- Twitter --*/}
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:title" content={metatag.title}/>
          <meta name="twitter:description" content={metatag.description}/>
          <meta name="twitter:image" content={metatag.image}/>
       </Helmet>
        <Navigation />
        <GalleryGridFront title={companyInfo.title} first={Front} themeColor={companyInfo.themeColor}/>

        <ProjectInfo
          title={companyInfo.name}
          role={companyInfo.role}
          fields={companyInfo.fields}
          time={companyInfo.time}
          description={companyInfo.paragraph}
          dotPoints={list}/>

        {/*----- Who are SEEK ------*/}
        <ImageGridx1
          first={aboutSEEK.image}
          innerDescription={<BriefIcon summary={aboutSEEK.summary} titleIcon={<PenIcon color={aboutSEEK.textColor}/>}
          title={aboutSEEK.title}
          paragraph={aboutSEEK.paragraph} textColor={aboutSEEK.textColor}/>}themeColor={aboutSEEK.themeColor}
          showTriangle
        />

        {/*----- background ------*/}
        <Paragraph
          titleText={SKProfile.summary}
          heading={SKProfile.heading}
          paragraph={SKProfile.paragraph}
        />

        <ImageGridx1
          first={SKMentalModel}
          caption="A storyboard to illustrate the traditional (once innovative!) mental model of finding a job."
        />

        <Paragraph
          paragraph={SKProfile.paragraph_2 + "\n\n" + SKProfile.paragraph_3}
        />

      {/*----- strategy ------*/}
        <GalleryGridx1
          first={SK_flowLicence}
        />
        <Paragraph
          titleText={SKDiscvoer.summary}
          heading={SKDiscvoer.heading}
          paragraph={SKDiscvoer.paragraph + "\n\n" + SKDiscvoer.paragraph_2}
        />

        <GalleryGridx2
          first={SKInterview}
          second={SKSynthesise}
          caption={SKDiscvoer.caption_2}
        />
        <Paragraph
          paragraph={SKDiscvoer.paragraph_3 + "\n\n" + SKDiscvoer.paragraph_4}
        />
        {/*----- usability ------*/}
        <GalleryGridx1
          first={SKIdeation}
        />
        <Paragraph
          titleText={SKUsabilityTesting.summary}
          heading={SKUsabilityTesting.heading}
          paragraph={SKUsabilityTesting.paragraph}
        />
        <GalleryGridx2
          first={SKTest}
          second={SKTest_result}
          caption={SKUsabilityTesting.caption}
        />
        <ImageGridx1
          first={SKTreeTest}
          caption={SKUsabilityTesting.caption_2}
        />
        <Paragraph
          paragraph={SKUsabilityTesting.paragraph_2 + "\n\n" + SKUsabilityTesting.paragraph_3}
        />

        {/*----- three points ------*/}
        <ProcessThreeSteps
          heading="Highlights"
          first="Right to work"
          firstDetail="Securely verifying work permits without revealing personal information."
          second="Licences & Certifications"
          secondDetail="Introducing a new menu to showcase professional credentials."
          third="Design optimisations"
          thirdDetail="Solving the most painful issues for customers by analysing support requests."
        />

        {/*Front page*/}
        <NextUp
          previous="Performance Leader"
          previousURL="/performanceLeader"
          next="About me"
          nextURL="/about"
        />
        <WarpLarge progressMode/>
        <Footer/>
      </div>
    );
  }
}

export default PortfolioSEEK;



// WEBPACK FOOTER //
// ./src/PortfolioSEEK.js